<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择违章"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'certificatesInsuranceFee'">
          <span>{{scope.row[scope.column.property] / 100}}</span>
        </section>
        <section v-else>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  violationList,
} from 'api/cost';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'plateNumber',
      tableSelectTar: 'recordId',
      searchBoxDataTmpl: {
        form: [
          { // 违章时间
            label: '违章时间',
            value: 'violationTime',
            type: 'date',
            default: [],
            placeholder: '请选择违章时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '违章类型',
            value: 'reviewType',
            type: 'select',
            placeholder: '请选择违章类型',
            options: [
              {
                label: '电子眼',
                value: 1,
              },
              {
                label: '现场单',
                value: 2,
              },
            ],
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'licenceTypeName',
          label: '证照类型',
        },
      ],
      tableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号',
        },
        {
          prop: 'categoryIdName',
          label: '违章类型',
        },
        {
          prop: 'violationTime',
          label: '违章时间',
        },
        {
          prop: 'locationName',
          label: '违章城市',
        },
        {
          prop: 'violationAddress',
          label: '违章地点',
        },
        {
          prop: 'violationCode',
          label: '违章代码',
        },
        {
          prop: 'violationPoint',
          label: '扣分数',
        },
        {
          prop: 'violationFine',
          label: '罚金（元）',
        },
        {
          prop: 'violationReason',
          label: '违章行为',
        },
        {
          prop: 'personLiable',
          label: '责任人',
        },
        {
          prop: 'recordStateName',
          label: '是否已处理',
        },
      ],
    };
  },
  methods: {
    getListApi: violationList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      if (searchBoxData.violationTime[0]) {
        searchBoxData.violationTimeBegin = this.formatDate(searchBoxData.violationTime[0], 1);
        searchBoxData.violationTimeEnd = this.formatDate(searchBoxData.violationTime[1], 1);
      }
      delete searchBoxData.violationTime;
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
